    import React, { useState } from "react";
    import { useLocation } from "react-router-dom";
    import { loadStripe } from "@stripe/stripe-js";
    import {
    Elements,
    CardNumberElement,
    CardExpiryElement,
    CardCvcElement,
    useStripe,
    useElements
    } from "@stripe/react-stripe-js";

    const stripePromise = loadStripe(
    "pk_test_51RuH1vCfbiTRrdphrSPcogd63xozJBCRs39OYy7TQ33L75zEji95fdsHPrpkFT512xJLsbJ3SdGW0qJu4J4H5Per00VYiiyTnt"
    );

    const ELEMENT_OPTIONS = {
    style: {
        base: {
        color: "#32325d",
        fontSize: "16px",
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        "::placeholder": { color: "#d8dcdfff" },
        },
        invalid: { color: "#fa755a" },
    },
    };

    const CheckoutForm = ({ clientSecret, setSuccess }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError(null);
        setLoading(true);

        if (!stripe || !elements) {
        setError("لم يتم تحميل Stripe بعد");
        setLoading(false);
        return;
        }

        const cardNumberElement = elements.getElement(CardNumberElement);
        const { error, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
        payment_method: { card: cardNumberElement },
        });

        if (error) {
        setError(error.message);
        } else if (paymentIntent.status === "succeeded") {
        setSuccess(true);
        }
        setLoading(false);
    };

    return (
        <form
        onSubmit={handleSubmit}
        className="bg-white bg-opacity-20 backdrop-blur-xs rounded-xl p-6 shadow-lg w-full max-w-md mx-auto space-y-6 border border-white/30
                    animate-fadeInUp"
        >
        <h2 className="text-2xl font-bold text-pink-600 mb-4 text-center">
            معلومات الدفع
        </h2>
        <div>
            <label className="block text-sm font-medium text-white mb-1">رقم البطاقة</label>
            <div className="border border-white/50 rounded p-3 bg-white bg-opacity-10">
            <CardNumberElement options={ELEMENT_OPTIONS} />
            </div>
        </div>

        <div>
            <label className="block text-sm font-medium text-white mb-1">تاريخ الانتهاء</label>
            <div className="border border-white/50 rounded p-3 bg-white bg-opacity-10">
            <CardExpiryElement options={ELEMENT_OPTIONS} />
            </div>
        </div>
        <div>
            <label className="block text-sm font-medium text-white mb-1">CVC</label>
            <div className="border border-white/50 rounded p-3 bg-white bg-opacity-10">
            <CardCvcElement options={ELEMENT_OPTIONS} />
            </div>
        </div>

        {error && <div className="text-red-400 text-center">{error}</div>}

        <button
            type="submit"
            disabled={!stripe || loading}
            className="w-full bg-pink-500 bg-opacity-80 text-white py-3 rounded-lg hover:bg-pink-600 transition disabled:opacity-60 disabled:cursor-not-allowed"
        >
            {loading ? "جارٍ الدفع..." : "ادفع الآن"}
        </button>
        </form>
    );
    };

    export default function Payment() {
    const location = useLocation();
    const { clientSecret } = location.state || {};
    const [success, setSuccess] = useState(false);

    if (!clientSecret) {
        return <div className="text-center mt-10 text-white">لا توجد عملية دفع جارية</div>;
    }

    return (
        <div
        className="min-h-screen flex items-center justify-center bg-cover bg-center relative"
        style={{ backgroundImage: "url('/stripe.jpg')" }}
        >
        <div className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>
        <div className="relative z-10 p-4 w-full max-w-md">
            <Elements stripe={stripePromise} options={{ clientSecret }}>
            {success ? (
                <div className="bg-white bg-opacity-20 backdrop-blur-md p-8 rounded-xl shadow-lg text-center border border-white/30
                                animate-fadeInUp">
                <h2 className="text-2xl font-bold text-green-400 mb-4">✅ تم الدفع بنجاح</h2>
                <p className="text-white">شكراً لك! تم إتمام عملية الدفع بنجاح.</p>
                </div>
            ) : (
                <CheckoutForm clientSecret={clientSecret} setSuccess={setSuccess} />
            )}
            </Elements>
        </div>
        </div>
    );
    }
